import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCSunjdHl5WTvrdSTsF-WWlVuOzusNtAdM",
  authDomain: "rushputtbackend.firebaseapp.com",
  projectId: "rushputtbackend",
  storageBucket: "rushputtbackend.firebasestorage.app",
  messagingSenderId: "644378357224",
  appId: "1:644378357224:web:ad5b041dea169b8fac485d",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
